import React from 'react'
import RoomsFilter from './RoomsFilter'
import RoomsList from './RoomsList'
import {RoomConsumer, withRoomConsumer} from '../context'
import Loading from './Loading'

function RoomsContainer({context}){
    const {loading , sortedRooms,rooms}=context
        if(loading){
            return <Loading/>
        }
        return(
        <>
           
            <RoomsFilter rooms={rooms}/>
            <RoomsList rooms={sortedRooms}/>

        </>
        ); 
}

export default withRoomConsumer (RoomsContainer)


// import React from 'react'
// import RoomsFilter from './RoomsFilter'
// import RoomsList from './RoomsList'
// import {RoomConsumer} from '../context'
// import Loading from './Loading'

// export default function RoomsContainer() {
//     return (
//         <RoomConsumer>
//         {
//             (value)=>{
//                 const {loading , sortedRooms,rooms}=value
//                 if(loading){
//                     return <Loading/>
//                 }
//                return(
//                 <div>
//                     Hello from rooms container
//                     <RoomsFilter rooms={rooms}/>
//                     <RoomsList rooms={sortedRooms}/>
        
//                 </div>
//                ); 
//             }
//         }
        
//         </RoomConsumer>

        
//     );
// }
